/*eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box, Avatar } from '@material-ui/core';
import { ReactComponent as PersonIcon } from '../../assets/images/User.svg';
import { backendLocalUrl } from '../../constants/globalConstants';
import useCommunityList from '../../hooks/useCommunityList';

/**
 * Common component for displaying user information across different sections
 * (Amenities, About, Jobs, Residents, Cost of Living, Climate, Getting Around, Education, Healthcare)
 */
const SectionUserInfo = ({
  communityDetails,
  repDetails,
  // isAdminEntry,
  getUserNameFunction,
  getRoleDescriptionFunction,
  aboutUser, // Special case for About component
  className = 'UserInfoName UserInfoIP',
}) => {
  const { getUserName, getRoleDescription } = useCommunityList();

  // Use provided functions or default ones
  const getDisplayName = getUserNameFunction || getUserName;
  const getRoleDesc = getRoleDescriptionFunction || getRoleDescription;
  console.log(repDetails, getUserNameFunction, aboutUser, getDisplayName, '0000000');
  // Determine whether About user should be shown (only if added by Admin or current CR)
  const hasAboutUser = aboutUser !== null && aboutUser !== undefined;
  //const isAboutFromAdmin = hasAboutUser && (aboutUser?.roleId === 2 || aboutUser?.roleId === 0);
  // const isAboutFromCurrentCR =
  //   hasAboutUser && aboutUser?.id === communityDetails?.userrole?.[0]?.id;
  const shouldShowAboutUser = hasAboutUser;

  // Determine user data based on admin entry status or special about user
  let userData;
  if (hasAboutUser) {
    userData = shouldShowAboutUser ? aboutUser : null;
  } else {
    userData = repDetails;
  } /* else if (isAdminEntry) {
    userData = repDetails;
  } else {
    userData = communityDetails?.userrole?.[0];
  } */

  // Get profile picture URL
  const getProfilePicUrl = () => {
    let profilePic;

    if (shouldShowAboutUser) {
      profilePic = aboutUser?.profilePic;
    } else if (hasAboutUser) {
      // About user exists but shouldn't be shown; return empty (no fallback)
      return '';
    } else {
      profilePic = repDetails?.profilePic;
    } /* else if (isAdminEntry) {
      profilePic = repDetails?.profilePic;
    } else {
      profilePic = communityDetails?.userrole?.[0]?.profilePic;
    } */

    if (!profilePic) return '';

    return window.location.hostname === 'localhost'
      ? `${backendLocalUrl}/${profilePic}`
      : `/api/${profilePic}`;
  };

  // Get user designation text
  const getUserDesignation = () => {
    if (shouldShowAboutUser) {
      // For About component, use getRoleDescription function
      return (
        getRoleDesc(aboutUser?.roleId, communityDetails?.userrole?.[0]?.userDesignationText) || ''
      );
    }
    if (hasAboutUser) {
      // About user exists but shouldn't be shown
      return '';
    }
    // if (isAdminEntry) {
    if (repDetails === 'No Data.') {
      return '';
    }
    return (
      getRoleDesc(repDetails?.roleId, communityDetails?.userrole?.[0]?.userDesignationText) || ''
    );
    // }
    // return communityDetails?.userrole?.[0]?.userDesignationText || '';
  };

  // Get display name for alt text
  const getAltText = () => {
    if (shouldShowAboutUser) {
      return `${aboutUser?.firstName || ''}`.trim();
    }
    if (hasAboutUser) {
      return '';
    }
    // if (isAdminEntry) {
    return repDetails?.firstName || '';
    // }
    // return getDisplayName(communityDetails?.userrole?.[0]) || '';
  };

  // Get last name
  const getLastName = () => {
    if (shouldShowAboutUser) {
      return aboutUser?.lastName || '';
    }
    if (hasAboutUser) {
      return '';
    }
    // if (isAdminEntry) {
    return repDetails?.lastName || '';
    // }
    // return communityDetails?.userrole?.[0]?.lastName || '';
  };

  return (
    <Box className={className}>
      <Avatar className="UserAvatar small" alt={getAltText()} src={getProfilePicUrl()}>
        <PersonIcon />
      </Avatar>
      <Box className="UserInfoText">
        <Typography variant="h6">
          <Box component="span" className="FirstName">
            {getDisplayName(userData)}
          </Box>
          <Box component="span" className="LastName">
            {getLastName()}
          </Box>
        </Typography>
        <Typography variant="caption">{getUserDesignation()}</Typography>
      </Box>
    </Box>
  );
};

SectionUserInfo.propTypes = {
  communityDetails: PropTypes.shape({
    userrole: PropTypes.array,
  }).isRequired,
  repDetails: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    profilePic: PropTypes.string,
  }),
  // isAdminEntry: PropTypes.bool.isRequired,
  getUserNameFunction: PropTypes.func,
  getRoleDescriptionFunction: PropTypes.func,
  aboutUser: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    profilePic: PropTypes.string,
    roleId: PropTypes.number,
  }),
  className: PropTypes.string,
};

SectionUserInfo.defaultProps = {
  repDetails: null,
  getUserNameFunction: null,
  getRoleDescriptionFunction: null,
  aboutUser: null,
  className: 'UserInfoName UserInfoIP',
};

export default SectionUserInfo;
